﻿import React from 'react';
import RawHtml from '../../UI/RawHtml';

const UspText = (props) => {

    return (
        <div className="employer-branding__usp__container__content">
            <RawHtml className={'employer-branding__usp__container__content__heading'}>{props.heading}</RawHtml>
            <RawHtml className={'employer-branding__usp__container__content__text'}>{props.text}</RawHtml>
        </div>
     )
 }                

export default UspText;